import { render, staticRenderFns } from "./editLeaderboardBanner.vue?vue&type=template&id=8c57491a&lang=pug"
import script from "./editLeaderboardBanner.vue?vue&type=script&lang=js"
export * from "./editLeaderboardBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports